var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEvent = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66652 1.5C0.36482 1.5 -0.432765 2.98978 0.249451 4.14689L10.5829 21.6735C11.2327 22.7755 12.7673 22.7755 13.4171 21.6735L23.7505 4.14689C24.4328 2.98978 23.6352 1.5 22.3335 1.5H1.66652Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEvent);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/event.27e70cb34bd2dabe72517e09f5a30b73.svg";